import img1 from "../../assets/portfolio2.png";
import img2 from "../../assets/portfolio1.png";
import img3 from "../../assets/portfolio3.png";
import img4 from "../../assets/portfolio4.png";
import img5 from "../../assets/portfolio5.png";
import img6 from "../../assets/portfolio6-1.png"


const data= [
    {id : 1 , image : img1 , title : "Keep Your Note ", gitHub : "https://github.com/Akb98443/Note-Keeper-App", liveDemo : "https://save-your-notes.vercel.app/"},
    {id : 2 , image : img2 , title : "Post-Your-Days- A blog application", gitHub : "https://github.com/Akb98443/blog-website.git", liveDemo : "https://myblog-front.onrender.com"},
    {id : 3 , image : img3 , title : "Play your music", gitHub: "https://github.com/Akb98443/Drum-Kit.git", liveDemo : "https://voluble-blini-7addc4.netlify.app/"},
    {id : 4 , image : img4 , title : "Tin Dog", gitHub: "https://github.com/Akb98443/tindogWebsite.git", liveDemo : "https://dog-loverakb.netlify.app/"},
    {id : 5 , image : img5, title : "Word Guessing Game", gitHub: "https://github.com/Akb98443/GuessTheWord.git", liveDemo : "https://guess-the-word-ak.netlify.app/"},
    {id :  6, image : img6, title : "Chat-vine", gitHub: "https://github.com/Akb98443/chatVine-A-chat-app", liveDemo : "https://chatvine.onrender.com"},

]


export default data;


